import { render, staticRenderFns } from "./AiAssessmentEnter.vue?vue&type=template&id=5e3d7164&scoped=true"
import script from "./AiAssessmentEnter.vue?vue&type=script&lang=js"
export * from "./AiAssessmentEnter.vue?vue&type=script&lang=js"
import style0 from "./AiAssessmentEnter.vue?vue&type=style&index=0&id=5e3d7164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d7164",
  null
  
)

export default component.exports